import { createSelector } from 'reselect';
import { selectPaidPublication } from './selectPaidPublication';
import { IPaidPublicationState } from '../types';

export const selectHighDemandCoefficient = createSelector(
  selectPaidPublication,
  (paidPublication: IPaidPublicationState) => paidPublication.highDemandCoefficient,
);
